import './account-membership.css';
import './account-opportunities.css';
import './become-a-partner.css';
import './coins-balance.css';
import './common.css';
import './giveaways.css';
import './header-profile.css';
import './home.css';
import './referrer.css';
import './partners.css';
import './sign-up.css';

export default {};